/**
 * Analytics utility for tracking events with Plausible
 * Provides a safe wrapper around Plausible's tracking functionality
 */

/* eslint-disable no-undef */

// Type definitions for better TypeScript support
declare global {
    interface Window {
        plausible?: (event: string, options?: { props?: Record<string, unknown> }) => void;
        plausible_q?: unknown[];
    }
}

// Safe Plausible wrapper
export function track(event: string, props?: Record<string, unknown>): void {
    if (typeof window === 'undefined') return;

    const fn = (
        window as Window & {
            plausible?: (event: string, options?: { props?: Record<string, unknown> }) => void;
        }
    ).plausible;
    if (typeof fn === 'function') {
        fn(event, props ? { props } : undefined);
    }
}
